import m from "clsx";
import e from "react";
import { s as l } from "../../../../../RideGlyph.module-CgKw9y7i.mjs";
function c({
  size: C = "small",
  accessibilityTitle: t = "glyph wheelchair solid",
  className: r,
  "data-testid": a,
  fill: s,
  stroke: i
}) {
  const o = () => m(r, l["ride-glyph"], {
    [l[`size-${C}`]]: C
  });
  return /* @__PURE__ */ e.createElement("div", { className: o(), "data-testid": a }, /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: s || "#03050F",
      stroke: i || "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    t && /* @__PURE__ */ e.createElement("title", null, t),
    /* @__PURE__ */ e.createElement("path", { d: "M27.3895 22.611L25.1076 23.589L21.3554 17.0039H18.1182C17.4553 15.7502 16.4503 14.7103 15.2201 14.0047H18.9886V11.0088H10.6757L10.4671 9.8646C11.1946 9.65901 11.8357 9.22262 12.2937 8.62114C12.7517 8.01966 13.0019 7.28566 13.0066 6.52967C13.0066 5.60309 12.639 4.71436 11.9844 4.05856C11.3298 3.40276 10.4418 3.03347 9.5152 3.03174C8.59031 3.03605 7.70479 3.40648 7.05232 4.062C6.39985 4.71753 6.03356 5.60478 6.03357 6.52967C6.03596 7.0474 6.15433 7.55803 6.37999 8.02401C6.60564 8.48999 6.93285 8.89948 7.33755 9.22239L8.16884 13.8287C6.93213 14.4509 5.8924 15.4042 5.16545 16.5824C4.43851 17.7606 4.05288 19.1174 4.05151 20.5018C4.05151 22.487 4.83878 24.3912 6.24068 25.7967C7.64258 27.2023 9.54467 27.9945 11.5298 27.9997C13.515 27.9997 15.4192 27.2125 16.8248 25.8106C18.2303 24.4087 19.0226 22.5066 19.0277 20.5214C19.0277 20.3519 19.0277 20.1954 19.0017 20.0194H19.6537L23.8394 27.3934L28.5696 25.3624L27.3895 22.611ZM11.507 22.9892C11.1793 22.9892 10.8547 22.9246 10.5519 22.799C10.2491 22.6735 9.97407 22.4895 9.74245 22.2576C9.51083 22.0257 9.3272 21.7504 9.20206 21.4474C9.07693 21.1445 9.01274 20.8198 9.01317 20.4921C9.01317 20.1643 9.07777 19.8397 9.20331 19.5369C9.32884 19.2342 9.51283 18.9591 9.74475 18.7275C9.97667 18.4959 10.252 18.3122 10.5549 18.1871C10.8579 18.0619 11.1825 17.9978 11.5103 17.9982C11.8381 17.9982 12.1626 18.0628 12.4654 18.1883C12.7682 18.3139 13.0432 18.4979 13.2749 18.7298C13.5065 18.9617 13.6901 19.237 13.8153 19.5399C13.9404 19.8429 14.0046 20.1675 14.0042 20.4953C14.0042 20.8231 13.9395 21.1476 13.814 21.4504C13.6885 21.7532 13.5045 22.0283 13.2726 22.2599C13.0406 22.4915 12.7653 22.6751 12.4624 22.8003C12.1595 22.9254 11.8348 22.9896 11.507 22.9892V22.9892Z" })
  ));
}
export {
  c as RideGlWheelchairSolid
};
